import React from 'react';
import { createPortal } from 'react-dom';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmButtonText?: string;
  confirmButtonClass?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = 'Confirm',
  confirmButtonClass = 'bg-status-warn hover:bg-status-warn active:bg-status-warn focus:ring-status-warn',
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] p-4 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm animate-in zoom-in-95 duration-200" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 text-center">
          <h3 className="text-lg font-bold text-text-ink">{title}</h3>
          <p className="text-text-muted mt-2 text-sm" style={{ textWrap: 'pretty' }}>{message}</p>
        </div>
        <div className="px-6 py-4 bg-app-bg rounded-b-2xl flex justify-end gap-3">
          <button onClick={onClose} className="bg-white border border-app-border text-text-ink text-sm font-medium py-2 px-4 rounded-lg hover:bg-app-bg transition-colors">
            Cancel
          </button>
          <button onClick={onConfirm} className={`text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors active:scale-95 ${confirmButtonClass}`}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;